import { render, staticRenderFns } from "./matterList.vue?vue&type=template&id=7976075d"
import script from "./matterList.vue?vue&type=script&lang=js"
export * from "./matterList.vue?vue&type=script&lang=js"
import style0 from "./matterList.vue?vue&type=style&index=0&id=7976075d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports